import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

export interface FileTypeConfig {
  restServer: string;
  wijmoLicenseKey: string;
}


@Injectable({
  providedIn: 'root'
})
export class FileTypeService {

  constructor(private httpClient: HttpClient,
    @Inject('fileTypeServiceConfig') private env: FileTypeConfig) { }

  private restServer = this.env.restServer;
 
  /**
   * Validate a file based on a file type
   */
  validateDataFile (file_id: number, file_type_id: number): Observable<any> {
    return this.httpClient.get(
      `${this.restServer}/data_package/file_type/validate_bioconnect_data_file/?file_id=${file_id}&file_type_id=${file_type_id}`
    );
  }
}